import React, { useState, useRef, useMemo } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import { appUrl } from "../../../constants/url-constants";
import { Text } from "@cars24/turbo-web/lib/text";
import chevronIcon from "./images/chevron.svg";

const EChallanCities = ({
    title = "View traffic rules and challans in your area",
    cityList = [],
    limit = NUMBER.EIGHT
}) => {
    const listRef = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const visibleCities = useMemo(
        () => (isOpen ? cityList : cityList.slice(0, limit)),
        [isOpen, cityList, limit]
    );
    const onViewMoreHandler = () => {
        if (isOpen && listRef && listRef.current) {
            window.setTimeout(() => {
                listRef.current.scrollIntoView();
            }, NUMBER.ZERO);
        }
        setIsOpen(!isOpen);
    };

    if (!cityList || !cityList.length) return null;

    const renderStateList = () => {
        return visibleCities.map(item => (
            <a href={`${appUrl()}/e-challan-${item.slug || ""}/`} key={item.cityId}>
                <div styleName={"styles.container"}>
                    <Text size="200" fontWeight="medium">
                        {item.name}
                    </Text>
                    <div>
                        <img src={chevronIcon} alt="chevron" />
                    </div>
                </div>
            </a>
        ));
    };

    return (
        <div
            styleName={`styles.eChallanLocateWiseChallans ${
                isOpen ? "styles.eChallanLocateWiseChallansText" : ""
            }`}
        >
            <h2>{title}</h2>
            <div ref={listRef} styleName={"styles.eChallanLocateWiseWrapper"}>
                {renderStateList()}
            </div>
            {cityList && cityList.length > limit && (
                <div
                    styleName={"styles.viewMore"}
                    className="shrinkOnTouch"
                    onClick={onViewMoreHandler}
                >
                    {isOpen ? "View less cities" : "View all cities"}
                </div>
            )}
        </div>
    );
};

EChallanCities.propTypes = {
    title: PropTypes.string,
    cityList: PropTypes.array.isRequired,
    limit: PropTypes.number,
    description: PropTypes.string,
    isSSR: PropTypes.bool
};

export default EChallanCities;
